module.exports = __webpack_public_path__ + "img/logo-instagram.30df8527.svg";